import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Calendar, User } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloatingButton from "@/components/WhatsAppFloatingButton";
import { fetchPublishedPosts } from "@/lib/blog";
import { usePageMeta } from "@/hooks/usePageMeta";

const Blog = () => {
  usePageMeta({
    description:
      "Blog TopClass Imóveis — artigos, análises e guias sobre o mercado imobiliário de alto padrão no Rio de Janeiro, investimento em Airbnb, valorização por bairro e dicas para compradores e investidores.",
    keywords:
      "Blog imobiliário Rio de Janeiro, Mercado imobiliário RJ, Investimento em imóveis, Airbnb Copacabana, Valorização Ipanema, Coberturas Lagoa",
  });

  const { data: posts = [], isLoading } = useQuery({
    queryKey: ["blog", "published"],
    queryFn: fetchPublishedPosts,
  });

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <header className="max-w-3xl mx-auto text-center mb-12">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-4">
              Blog TopClass Imóveis
            </h1>
            <p className="text-lg text-muted-foreground font-body">
              Análises, guias e novidades sobre o mercado imobiliário de alto padrão no Rio de Janeiro.
            </p>
          </header>

          {isLoading ? (
            <p className="text-center text-muted-foreground">Carregando...</p>
          ) : posts.length === 0 ? (
            <p className="text-center text-muted-foreground">Nenhum post publicado ainda.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {posts.map((p) => (
                <Link
                  key={p.id}
                  to={`/blog/${p.slug}`}
                  className="group bg-card rounded-lg overflow-hidden shadow-lg border border-border transition-all hover:shadow-xl hover:-translate-y-1"
                >
                  {p.cover_image && (
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={p.cover_image}
                        alt={p.title}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  )}
                  <div className="p-5">
                    <h2 className="font-display text-xl font-bold text-foreground mb-2 line-clamp-2">
                      {p.title}
                    </h2>
                    {p.excerpt && (
                      <p className="text-sm text-muted-foreground font-body line-clamp-3 mb-3">
                        {p.excerpt}
                      </p>
                    )}
                    <div className="flex items-center gap-3 text-xs text-muted-foreground font-body">
                      {p.author && (
                        <span className="inline-flex items-center gap-1">
                          <User className="h-3 w-3" /> {p.author}
                        </span>
                      )}
                      {p.published_at && (
                        <span className="inline-flex items-center gap-1">
                          <Calendar className="h-3 w-3" />
                          {new Date(p.published_at).toLocaleDateString("pt-BR")}
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Blog;
